<ng-container *mobxAutorun>
  <ng-container *ngIf="shouldDisplay">
    <!-- Required icon -->
    <lf-icon
      class="is-required"
      icon="asterisk"
      *ngIf="showIsRequired && !isReadOnly"
    ></lf-icon>

    <!-- Pending validation -->
    <div
      class="status pending"
      *ngIf="relativeStorage.shouldShowPending()"
    ></div>
    <!-- Rejected validation -->
    <div
      class="status rejected"
      *ngIf="relativeStorage.shouldShowRejected()"
      (click)="relativeStorage.recomputeStateProperties()"
    >
      <lf-tooltip [help]="retryValidateText">
        <lf-icon icon="warning"></lf-icon>
      </lf-tooltip>
    </div>

    <!-- (Debug) value state -->
    <lf-value-state [path]="path"></lf-value-state>

    <!-- Input group -->
    <div
      class="lf-checkable input-group input-group-sm"
      [class.is-warning]="relativeStorage.shouldShowWarning()"
      [class.is-invalid]="relativeStorage.shouldShowError()"
    >
      <!-- Code -->
      <div *ngIf="code" class="input-group-prepend">
        <div class="input-group-text">{{ code }}</div>
      </div>

      <!-- Checkbox -->
      <label
        class="form-control custom-control custom-checkbox"
        [class.is-warning]="relativeStorage.shouldShowWarning()"
        [class.is-invalid]="relativeStorage.shouldShowError()"
        [class.is-readonly]="isReadOnly"
      >
        <!-- Actual checkbox -->
        <!--
          Note that checkboxes don't support `readonly`, so we use the
          `disabled` attribute
        -->
        <input
          #focusTarget
          type="checkbox"
          class="custom-control-input"
          [name]="path"
          [checked]="relativeStorage.get()"
          [indeterminate]="relativeStorage.get() === null"
          (change)="_onCheckboxChange($event)"
          [disabled]="isReadOnly"
          (focus)="_onFocus($event)"
          (blur)="_onBlur($event)"
        />

        <!-- Label -->
        <span class="custom-control-label">
          <span *ngIf="label" class="label">{{ label }}</span>
          <lf-help-tooltip
            *ngIf="helpMessage"
            [help]="helpMessage"
          ></lf-help-tooltip>
        </span>
      </label>
    </div>

    <!-- Legend -->
    <div *ngIf="legend" class="legend">{{ legend }}</div>
  </ng-container>
</ng-container>
